<template>
  <div class="batch-match-expert wrap-content">
    <div class="wrap-oper">
      <Button type="default" @click="back" class="save">返回</Button>
    </div>
    <div class="wrap-inner">
      <div class="wrap-form">
        <label class="form-label">学生信息</label>
        <Table ref="studentTable" border :columns="from==='unit'?unitColumns:columns" :data="studentList" @on-selection-change="handleSelectChange">
          <template slot-scope="{ row, index }" slot="rate">
            {{row.sendNum + '/' + row.auditExpertNum}}
          </template>
        </Table>
      </div>
      <div class="wrap-form" v-if="!readonly && from!=='unit'">
        <label class="form-label">可送单位</label>
        <div class="">
          <regular-page ref="sendUnitPage"
                        v-if="!loading"
                        config-path="batchSendUnit"
                        :parent-id="selectionIds.join(',')"
                        @reload="fetchDefaultMessage"
          ></regular-page>
        </div>
      </div>
      <div class="wrap-form" v-if="!readonly && from==='unit'">
        <label class="form-label">接收单位<span class="tips" @click="employer.show = true">找不到接收单位？点此新增接收单位</span></label>
        <div class="">
          <regular-page ref="sendUnitPage"
                        v-if="!loading"
                        config-path="batchSendUnitFromUnit"
                        :parent-id="selectionIds.join(',')"
                        @reload="fetchDefaultMessage"
          ></regular-page>
        </div>
      </div>
      <Spin size="large" fix v-if="loading"></Spin>
      <Modal v-model="employer.show"
             title="新增接收单位"
             @on-ok="dialogOK"
             :loading="employer.loading"
      >
        <employer-edit2 ref="employerEdit" v-if="employer.show"></employer-edit2>
      </Modal>
      <Modal v-model="unitFee.show"
             title="编辑费用"
             @on-ok="unitFeeOK"
             :loading="unitFee.loading"
      >
        <Form v-if="unitFee.show" :model="unitFeeData" :label-width="80" ref="editUnitFeeForm">
          <FormItem label="专家费" prop="expertFee" :rules="{required: true, message: '专家费不能为空', trigger: 'blur'}">
            <Input v-model="unitFeeData.expertFee" placeholder="请输入专家费"></Input>
          </FormItem>
          <FormItem label="管理费" prop="manageFee" :rules="{required: true,message: '管理费不能为空', trigger: 'blur'}">
            <Input v-model="unitFeeData.manageFee" placeholder="请输入管理费"></Input>
          </FormItem>
        </Form>
      </Modal>
      <Modal v-model="manageFee.show"
             title="分配管理费"
             @on-ok="manageFeeOK"
             :loading="manageFee.loading"
      >
        <Form v-if="manageFee.show" :model="unitFeeData" :label-width="120" ref="editUnitFeeForm">
          <FormItem label="本人管理费" prop="keepManageFee">
            <Input readonly v-model="unitFeeData.keepManageFee" placeholder="请输入本人管理费"></Input>
          </FormItem>
          <FormItem label="接收人管理费" prop="manageFee" :rules="{required: true, message: '接收人管理费不能为空', trigger: 'blur'}">
            <Input @on-change="changeManageFee" v-model="unitFeeData.manageFee" placeholder="请输入接收人管理费"></Input>
          </FormItem>
        </Form>
      </Modal>
    </div>
  </div>
</template>

<script>
import regularPage from '../../regularPage'
import expertMessage from '../../dialogs/systemManage/expertEdit'
import employerEdit2 from '../../dialogs/systemManage/employerEdit2'
export default {
  name: 'batchMatchUnit',
  components: {regularPage, expertMessage, employerEdit2},
  props: {
    query: ''
  },
  data () {
    return {
      currentId: '',
      selectionIds: [],
      columns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => {
            return h('Table', {
              props: {
                columns: [
                  {
                    title: '单位名称',
                    key: 'schoolName',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '学院',
                    key: 'department',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '接收状态',
                    key: 'acceptStatusName',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '联系人',
                    key: 'name',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '联系电话',
                    key: 'mobile',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '专家费',
                    key: 'expertFee',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '管理费',
                    key: 'manageFee',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '操作',
                    render: (h, row) => {
                      if (row.row.acceptStatus === '4' || row.row.acceptStatus === '5' || !row.row.canOperate) {
                        return '';
                      }
                      if (row.row.canOperate) {
                        return h('div', [
                          h('span', {
                            style: {
                              color: '#1890ff',
                              cursor: 'pointer',
                              marginRight: '10px'
                            },
                            on: {
                              click: () => {
                                this.showEditFeeDialog(row.row);
                              }
                            }
                          }, '编辑'),
                          h('span', {
                            style: {
                              color: '#1890ff',
                              cursor: 'pointer'
                            },
                            on: {
                              click: () => {
                                this.requestCancelSend(row.row);
                              }
                            }
                          }, '撤销')
                        ]);
                      } else {
                        // if (row.row.refuseFlag) {
                        //   return h('div', [
                        //     h('span', {
                        //       style: {
                        //         color: '#ff1818',
                        //         cursor: 'pointer',
                        //         marginRight: '10px'
                        //       }
                        //     }, '拒绝接收')
                        //   ]);
                        // } else {
                        //   return '';
                        // }
                        return '';
                      }
                    }
                  }
                ],
                data: params.row.receiveUnitList
              }
            })
          }
        },
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '学校',
          key: 'unitName'
        },
        {
          title: '学号',
          key: 'schoolNo',
          width: 120
        },
        {
          title: '姓名',
          key: 'authorName',
          width: 90
        },
        {
          title: '一级学科',
          key: 'firstSubjectName',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '二级学科',
          key: 'secondSubjectName',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '论文涉及研究方向',
          key: 'researchAera',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '论文题目',
          key: 'titleCn',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '已送审数',
          slot: 'rate',
          width: 80
        },
        {
          title: '单位提交时间',
          key: 'submitTime',
          ellipsis: true,
          tooltip: true
        }
      ],
      unitColumns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => {
            return h('Table', {
              props: {
                columns: [
                  {
                    title: '单位名称',
                    key: 'schoolName',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '学院',
                    key: 'department',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '接收状态',
                    key: 'acceptStatusName',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '联系人',
                    key: 'name',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '联系电话',
                    key: 'mobile',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '专家费',
                    key: 'expertFee',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '本人管理费',
                    key: 'keepManageFee',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '接收人管理费',
                    key: 'manageFee',
                    ellipsis: true,
                    tooltip: true
                  },
                  {
                    title: '操作',
                    render: (h, row) => {
                      if (row.row.acceptStatus === '5' || !row.row.canOperate) {
                        return '';
                      }
                      if (row.row.canOperate) {
                        return h('div', [
                          h('span', {
                            style: {
                              color: '#1890ff',
                              cursor: 'pointer',
                              marginRight: '10px'
                            },
                            on: {
                              click: () => {
                                this.showUnitEditFeeDialog(row.row);
                              }
                            }
                          }, '编辑'),
                          h('span', {
                            style: {
                              color: '#1890ff',
                              cursor: 'pointer'
                            },
                            on: {
                              click: () => {
                                this.requestCancelSend(row.row);
                              }
                            }
                          }, '撤销')
                        ]);
                      } else {
                        // if (row.row.refuseFlag) {
                        //   return h('div', [
                        //     h('span', {
                        //       style: {
                        //         color: '#ff1818',
                        //         cursor: 'pointer',
                        //         marginRight: '10px'
                        //       }
                        //     }, '拒绝接收')
                        //   ]);
                        // } else {
                        //   return '';
                        // }
                        return '';
                      }
                    }
                  }
                ],
                data: params.row.receiveUnitList
              }
            })
          }
        },
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '学校',
          key: 'unitName'
        },
        {
          title: '一级学科',
          key: 'firstSubjectName',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '二级学科',
          key: 'secondSubjectName',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '论文涉及研究方向',
          key: 'researchAera',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '论文题目',
          key: 'titleCn',
          ellipsis: true,
          tooltip: true
        }
      ],
      studentList: [],
      typeMap: {
        0: '其他',
        1: '博士生导师',
        2: '硕士生导师',
        3: '兼职博士生导师',
        4: '兼职硕士生导师',
        5: '行业导师'
      },
      positionMap: {
        '00': '无',
        '01': '初级',
        '02': '中级',
        '03': '副高级',
        '04': '正高级',
        '05': '讲师(博士学位)',
        '06': '副教授',
        '07': '教授'
      },
      expertDialogConfig: {
        show: false,
        expertId: ''
      },
      employer: {
        show: false,
        loading: true
      },
      unitFee: {
        show: false,
        loading: true
      },
      manageFee: {
        show: false,
        loading: true
      },
      unitFeeData: {
        expReviewId: '',
        expertFee: '',
        oldManageFee: '',
        oldKeepManageFee: '',
        manageFee: '',
        keepManageFee: '',
        totalManageFee: ''
      },
      from: '',
      loading: true
    }
  },
  created () {
    this.currentId = sessionStorage.getItem('batchSendThesisIds');
    this.selectionIds = this.currentId.split(',');
    this.readonly = Object.keys(this.$route.query).includes('readonly');
    this.from = this.query.split('=')[1] || this.$route.query.from;
    this.fetchDefaultMessage();
  },
  watch: {
  },
  methods: {
    fetchDefaultMessage () {
      const _self = this;
      _self.loading = true;
      let url = '/custom/sendPaper/infos';
      if (_self.from === 'unit') {
        url = '/school/schoolDegreeOffice/infos'
      }
      _self.post(url, _self.currentId.split(',')).then(res => {
        _self.studentList = res.data;
        _self.loading = false;
        _self.$nextTick(function () {
          _self.$refs.studentTable.selectAll(true);
        })
      });
    },
    // 发送请求取消送审
    requestCancelSend (unit) {
      let url = '/custom/sendPaper/delete';
      let param = {id: unit.expReviewId};
      if (this.from === 'unit') {
        url = '/school/schoolDegreeOffice/deleteSendAcademy';
      }
      this.post(url, param).then(res => {
        this.$Message.success('取消成功！');
        this.fetchDefaultMessage();
      })
    },
    // 显示修改费用弹窗
    showEditFeeDialog (params) {
      const _self = this;
      _self.unitFeeData.expReviewId = params.expReviewId;
      _self.unitFeeData.expertFee = params.expertFee || '0';
      _self.unitFeeData.manageFee = params.manageFee || '0';
      _self.unitFee.show = true;
    },
    showUnitEditFeeDialog (params) {
      const _self = this;
      _self.unitFeeData.expReviewId = params.expReviewId;
      _self.unitFeeData.keepManageFee = params.keepManageFee || '0';
      _self.unitFeeData.manageFee = params.manageFee || '0';
      _self.unitFeeData.oldKeepManageFee = params.keepManageFee || '0';
      _self.unitFeeData.oldManageFee = params.manageFee || '0';
      _self.unitFeeData.totalManageFee = parseInt(_self.unitFeeData.keepManageFee) + parseInt(_self.unitFeeData.manageFee)
      _self.manageFee.show = true;
    },
    changeManageFee () {
      const _self = this;
      let totalFee = _self.unitFeeData.totalManageFee
      let manageFee = 0
      if (_self.unitFeeData.manageFee !== '') {
        manageFee = parseInt(_self.unitFeeData.manageFee)
        if (manageFee > totalFee) {
          alert('接收人管理费不得大于当前最大管理费')
          _self.unitFeeData.keepManageFee = _self.unitFeeData.oldKeepManageFee
          _self.unitFeeData.manageFee = _self.unitFeeData.oldManageFee
        } else if (manageFee < 0) {
          alert('管理费不得小于0')
          _self.unitFeeData.keepManageFee = _self.unitFeeData.oldKeepManageFee
          _self.unitFeeData.manageFee = _self.unitFeeData.oldManageFee
        } else {
          _self.unitFeeData.keepManageFee = parseInt(totalFee) - parseInt(manageFee)
        }
      } else {
        _self.unitFeeData.keepManageFee = parseInt(totalFee)
      }
    },
    // 弹窗修改费用确定
    unitFeeOK () {
      const _self = this;
      _self.unitFeeData.manageFee = parseInt(_self.unitFeeData.manageFee)
      _self.unitFeeData.oldKeepManageFee = parseInt(_self.unitFeeData.oldKeepManageFee)
      _self.unitFeeData.oldManageFee = parseInt(_self.unitFeeData.oldManageFee)
      _self.$refs['editUnitFeeForm'].validate((valid) => {
        if (valid) {
          _self.post('/custom/sendPaper/changeFee', _self.unitFeeData).then(res => {
            _self.$Message.success('修改成功！');
            _self.fetchDefaultMessage();
            _self.unitFee.show = false;
          }).catch(() => {
            _self.unitFee.loading = false;
            _self.$nextTick(function () {
              _self.unitFee.loading = true;
            })
          });
        } else {
          _self.unitFee.loading = false;
          _self.$nextTick(function () {
            _self.unitFee.loading = true;
          })
        }
      });
      return false;
    },
    manageFeeOK () {
      const _self = this;
      _self.$refs['editUnitFeeForm'].validate((valid) => {
        if (valid) {
          _self.post('/school/schoolDegreeOffice/changeFee', _self.unitFeeData).then(res => {
            _self.$Message.success('修改成功！');
            _self.fetchDefaultMessage();
            _self.manageFee.show = false;
          }).catch(() => {
            _self.manageFee.loading = false;
            _self.$nextTick(function () {
              _self.manageFee.loading = true;
            })
          });
        } else {
          _self.unitFee.loading = false;
          _self.$nextTick(function () {
            _self.unitFee.loading = true;
          })
        }
      });
      return false;
    },
    dialogOK () {
      const _self = this;
      _self.$refs['employerEdit'].dialogComfirm().then(val => {
        // 确定成功后重刷页面
        _self.employer.show = false;
        _self.fetchDefaultMessage();
      }).catch((error) => {
        if (error.code === 500) {
          _self.employer.show = false;
          _self.fetchDefaultMessage();
        } else {
          _self.employer.loading = false;
          _self.$nextTick(function () {
            _self.employer.loading = true;
          })
        }
      });
    },
    back () {
      this.$emit('back');
    },
    handleSelectChange (selection) {
      // alert(this.from)
      let selectionIds = [];
      if (this.from === 'unit') {
        selection.every(item => selectionIds.push(item.expReviewId));
      } else {
        selection.every(item => selectionIds.push(item.id));
      }
      this.selectionIds = selectionIds;
    }
  }
}
</script>
<style lang="less">
  .batch-match-expert {
    .kh-table-body {
      td.kh-table-expanded-cell {
        padding: 10px;
      }
    }
  }
</style>
<style lang="less" scoped>
  .batch-match-expert {
    .form-label {
      .tips {
        color: @base-color;
        cursor: pointer;
        font-size: @font-size-small;
        font-weight: normal;
        margin-left: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/customPage/thesisManage/batchMatchUnit.vue